import { createAction, props } from '@ngrx/store'

export const SOURCE = '[Lpis Datasource]'

export const resetState = createAction(
    `${SOURCE} ResetState`,
)

export const setFilterArgs = createAction(
    `${SOURCE} SetFilterArgs`, props<{ args: any }>()
)